import {
    type MylensesRatingFormAction,
    type MylensesRatingFormActionType,
    type MylensesRatingFormSourceType,
} from "@snapchat/blizzard-schema";

export interface FeedbackRatingFormEventData {
    event: MylensesRatingFormAction["event_name"];
    action: MylensesRatingFormActionType;
    comment?: string;
    rating?: number;
}

export const createFeedbackRatingFormActionEvent = (
    { event, action, comment, rating }: FeedbackRatingFormEventData,
    sessionId: string,
): MylensesRatingFormAction => {
    const source: MylensesRatingFormSourceType = "MY_LENSES";

    const baseEventDetails = {
        event_name: event,
        action,
        mylenses_session_id: sessionId,
        source,
    };

    if (action === "SELECT_RATING") {
        // Blizzard schema expects rating to be a bigint
        return { ...baseEventDetails, rating } as MylensesRatingFormAction;
    }

    if (action === "SUBMIT") {
        // Blizzard schema expects rating to be a bigint
        return { ...baseEventDetails, comment, rating } as MylensesRatingFormAction;
    }

    return baseEventDetails;
};
